import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {FieldRecord} from "../../../../model/api/field-record";
import {OrderAmendmentTableComponent} from "../table/order-amendment-table.component";
import {OrderAmendmentChangeRequest} from "../../../../model/data-amendment/order-amendment-change-request";
import {OrderAmendmentService} from "../../../../services/data-amendment/order-amendment.service";
import {FormFieldConfig} from "../../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../../model/api/form-field-group-config";
import TYPE = FormFieldConfig.TYPE;
import {JsonProperty} from "@hyperloris/tyson";
import {DateFormatPipe} from "../../../../utils/date-format.pipe";

@Component({
  selector: 'app-order-amendment-dialog',
  templateUrl: './order-amendment-dialog.component.html',
  styleUrls: ['./order-amendment-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class OrderAmendmentDialogComponent extends CcBaseComponent {

  // fields
  templates: FieldRecord<any>[];

  transPartKey: string = 'order-amendment';

  @Input()
  dialogFormVisible: boolean = false;
  @Output()
  dialogFormVisibleChange = new EventEmitter<boolean>();

  @ViewChild('ccInvoiceDetailTable')
  public ccOrderAmendmentTable: OrderAmendmentTableComponent;

  FieldTypes = FormFieldConfig.TYPE;

  formConfig: FormFieldGroupConfig[];

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              private orderAmendment: OrderAmendmentService,
              private confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.formConfig = [{
      group: '',
      fields: [
        {
          field: 'businessDate',
          column: 2,
          type: TYPE.DATE,
        },
        {
          field: 'customerCode',
          column: 2,
          type: TYPE.AUTOCOMPLETE,
          options: () => []
        },
        {
          field: 'accountCode',
          column: 2,
          type: TYPE.AUTOCOMPLETE,
          options: () => []
        },
        {
          field: 'reference',
          column: 2,
          type: TYPE.TEXT,
        },
      ]
    }];
  }

  applyOrdersChange() {
    this.ccOrderAmendmentTable.tableLoading = true;
    this.ccOrderAmendmentTable.markForCheck();
    const toSaveOrders = JSON.parse(JSON.stringify(this.ccOrderAmendmentTable.records))
      .filter(order => order['hasChanged'] === true);
    toSaveOrders
      .forEach(order => {
        if (!order.account) order.account = {};
        order.account.name = order['accountName'];
        order.account.type = order['accountType'];
        order.account.reference1 = order['accountReference1'];
        order.account.reference2 = order['accountReference2'];
        order.account.reference3 = order['accountReference3'];
        DateFormatPipe.checkDate(order, 'businessDate');
        DateFormatPipe.checkDate(order, 'clearingDate');
        DateFormatPipe.checkDate(order, 'executionDate');
      });
    const request: OrderAmendmentChangeRequest = {
      orders: toSaveOrders,
    };
    this.orderAmendment.saveOrders(request).subscribe((value) => {
      this.closeDialog();
    });
  }

  reLoadRecords() {
    this.ccOrderAmendmentTable.reLoadRecords();
  }

  public isEditable() {
    return true;
  }

  // initRequest() {
  //   this.tableCurrentRequest = {
  //     businessDate: DateTime.now().minus({days: DateTime.now().weekday === 1 ? 3 : 1}).toFormat('dd/MM/yyyy'),
  //     customerCode: undefined,
  //     accountCode: undefined,
  //     reference: undefined,
  //     first: 0,
  //     rows: 1000,
  //     sortOrder: -1,
  //     sortField: 'modificationDate'
  //   };
  // }

  showDialog(): void {

    this.dialogFormVisible = true;
    this.dialogFormVisibleChange.emit(true);
    this.ccOrderAmendmentTable.ngOnInit();
    this.ccOrderAmendmentTable.refreshTable();
    this.markForCheck();
  }

  closeDialog(): void {
    this.dialogFormVisible = false;
    this.dialogFormVisibleChange.emit(false);
    this.markForCheck();
  }
}
